<div
  data-cy="product-card-promotions-banner"
  class="usf-product-card-promotions"
  (click)="bannerClick()"
>
  <span [attr.data-cy]="'product-promotions-banner-' + productNumber + '-text'">
    {{ offerBenefitDesc }}
  </span>
</div>
